import { v5 as uuidv5 } from 'uuid';

const NS = uuidv5('FOTOCLASS:archive@v1', uuidv5.URL);

export function deriveArchiveId(ids: string[]): { archiveId: string; sortedIds: string[] } {
  // Code unit, not localeCompare: the id order is part of the archiveId the backend keys the archive by.
  const sortedIds = [...new Set(ids)].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0));
  const archiveId = uuidv5(sortedIds.join(','), NS);
  return { archiveId, sortedIds };
}
